import settings from '@/settings'

let list = (filters, cnpj, headers) => {
  let url = `${settings.apetrusApi}/faturamentos/?posto=${cnpj}`

  Object.keys(filters).forEach(key => {
    url = `${url}&${key}=${filters[key]}`
  })

  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let info = (id, cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/faturamentos/${id}/?posto=${cnpj}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let inserirComprovante = (data, cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/faturamentos/inserircomprovante/?posto=${cnpj}`, {
    method: 'PATCH',
    mode: 'cors',
    body: JSON.stringify(data),
    headers: headers
  })
}

const pegarFaturas = (headers, cnpj, filters) => {
  let url = `${settings.apetrusApi}/faturamentos/pegarfaturamentoempresas/?posto=${cnpj}`

  Object.keys(filters).forEach(key => {
    url = `${url}&${key}=${filters[key]}`
  })

  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let confirmarPagamento = (id, cnpj, data, headers) => {
  return fetch(`${settings.apetrusApi}/faturamentos/${id}/?posto=${cnpj}`, {
    method: 'PATCH',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

export default {
  list,
  info,
  inserirComprovante,
  pegarFaturas,
  confirmarPagamento
}
